import { defineMessages } from 'react-intl';

export default defineMessages({
  header: 'Tidbokning',
  loadingErrorTitle: 'Oväntat fel',
  loadingErrorMessage: 'Något gick fel. Testa att ladda om sidan eller kontakta din vårdgivare.'
});
